export const userTraits = {
  eyeColor: ['Grün', 'Blau', 'Schwarz', 'Grau', 'Braun'],
  figure: ['Dünn', 'Normal', 'Sportlich', 'Mollig'],
  //smoker: ['Ja', 'Nein', 'Manchmal'],
  smoker: ['Ja', 'Nein'],
  isTattooed: ['Ja', 'Nein'],
  alcohol: ['Ja', 'Nein', 'Selten'],
  stay: ['Alleine', 'Bei den Eltern', 'WG', 'Mit Partner zusammen'],
  //relationship: ['Es ist kompliziert', 'Single', 'Vergeben'],
  relationship: ['Nicht Vergeben', 'Vergeben'],
  search: ['Affäre', 'Beziehung', 'Freunde', 'Spaß'],
  sexualOrientation: ['Heterosexuell', 'Bisexuell', 'Homosexuell'],
  children: ['Ja', 'Nein', 'möchte keine', 'möchte welche'],
  religion: ['Andere', 'Atheist', 'Buddhist', 'Hindu', 'Christ', 'Jüdisch', 'Moslem'],
  hairColor: ['Andere', 'Blond', 'Braun', 'Rot', 'Schwarz', 'Grau'],
  height: [
    120,
    121,
    122,
    123,
    124,
    125,
    126,
    127,
    128,
    129,
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    166,
    167,
    168,
    169,
    170,
    171,
    172,
    173,
    174,
    175,
    176,
    177,
    178,
    179,
    180,
    181,
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
  ],
};
